/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const e=e=>e.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase();export{e as camelToDash};
//# sourceMappingURL=camel-to-dash.js.map
